import React from 'react';

import { BreadcrumbStyles } from './BreadcrumbStyles';

export const BreadcrumbDividerSymbol = '/';

export function BreadcrumbDivider(): JSX.Element {
  return (
    <span className={BreadcrumbStyles.BreadcrumbDivider} aria-hidden="true">{BreadcrumbDividerSymbol}</span>
  );
}
